import {
  FilterInterfaceLightMinimal,
  FilterSetLightMinimal,
  JobSearchInterface,
  JobSearchLightInterface,
} from "src/app/core/interfaces/job-card-interface";
import { FilterInterface, FilterSet } from "src/app/core/interfaces/filter-interface";

export class JobSearchConverter {
  static toLightweight(fullSearch: JobSearchInterface): JobSearchLightInterface {
    return {
      selectedFilters: fullSearch.selectedFilters.map((fs) =>
        this.convertFilterSet(fs)
      ),
      locationSearchValue: fullSearch.locationSearchValue,
      pagination: fullSearch.pagination,
      useCustomProperties: fullSearch.useCustomProperties,
    };
  }

  private static convertFilterSet(
    filterSet: FilterSet
  ): FilterSetLightMinimal {
    return {
      filterSetType: filterSet.filterSetType,
      selectedFilters: filterSet.filters.map((f) =>
        this.convertFilterToLight(f)
      ),
    };
  }

  private static convertFilterToLight(
    filter: FilterInterface
  ): FilterInterfaceLightMinimal {
    return {
      spId: filter.spId,
      parentCode: filter.parentCode,
      filters: filter.filters
        ? filter.filters.map((f) => this.convertFilterToLight(f))
        : undefined,
      customProperties: filter.customProperties,
    };
  }
}
